import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'

import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../common/utils/appUtils'
import { navigate } from '../../common/utils/redirectionUtils'
import {
  ACTIVE_STATUS,
  APPROVAL_STATUS,
  COMMISSION_EARNINGS_TYPE,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PHARMACY_REQUEST_TYPE,
  PLATFORM_CHARGE_TYPE,
  PRODUCT_DETAIL_FIELDS,
  SUPPLIER_FIELDS,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import {
  addUpdateProductHelper,
  deleteUniversalPlatformChargesHelper,
  getAllPharmacyRequestHelper,
  getAllProductHelper,
  getAllSuppliersHelper,
  getPlatformChargesHelper,
  getMedicalCategoryHelper,
  getPharmacyDataHelper,
  updateProductHelper,
  updateSupplierHelper,
  upsertUniversalPlatformChargesHelper,
  updateUniversalPlatformChargesHelper,
  upsertIndividualPlatformChargesHelper,
  deleteIndividualPlatformChargesHelper,
  getCustomerPlatformChargesHelper,
  updateCustomerPlatformChargesHelper,
} from '../../helper/settings-helper'
import './PlatformCharges.scss'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import Alert from '../../components/Alert/Alert'
import {
  addProductAlertAction,
  addSupplierAlertAction,
  updateSupplierAlertAction,
} from '../../modules/actions/action'
import DotsIcon from '../../assets/DotsIcon'
import AddEarningIcon from '../../assets/AddEarnongIcon'
import MinusIcon from '../../assets/MinusIcon'

const PlatformCharges = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.MANAGE_CUSTOMER,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [activeType, setActiveType] = useState(
    COMMISSION_EARNINGS_TYPE.PHARMACY_STORE
  )
  const [managePharmacyRequestData, setManagePharmacyRequestData] = useState([])
  const [requestData, setRequestData] = useState([])
  const [filteredRequestData, setFilteredRequestData] = useState([])
  const [
    filteredManagePharmacyRequestData,
    setFilteredManagePharmacyRequestData,
  ] = useState([])
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})
  // const [updateProductAlert, setUpdateProductAlert] = useState(false)
  const [activeRowId, setActiveRowId] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [platformChargesData, setPlatformChargesData] = useState({})
  const [universalPlatformPercentage, setUniversalPlatformPercentage] =
    useState(undefined)
  const [
    universalCustomerPlatformCharges,
    setUniversalCustomerPlatformCharges,
  ] = useState(undefined)
  const [individualPlatformData, setIndividualPlatformData] = useState([])
  const [filteredIndividualPlatformData, setFilteredIndividualPlatformData] =
    useState([])
  const [supplierData, setSupplierData] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState()
  const [individualPlatform, setIndividualPlatform] = useState('')
  const [isAddRowActive, setAddRowActive] = useState(false)
  const [rowEditId, setRowEditId] = useState(undefined)
  const [refilterTrigger, setRefilterTrigger] = useState(0)
  const [isUniversalEdited, setUniversalEdited] = useState(false)
  const [isIndividualEdited, setIndividualEdited] = useState(false)
  const [isSaveButtonActive, setIsSaveButtonActive] = useState(false)

  useEffect(() => {
    getPlatformChargesData()
    getCustomerPlatformChargesData()
    getBranchData()
  }, [])

  useEffect(() => {
    if (isIndividualEdited || isUniversalEdited || isAddRowActive)
      setIsSaveButtonActive(true)
    else setIsSaveButtonActive(false)
  }, [isUniversalEdited, isIndividualEdited, isAddRowActive])

  useEffect(() => {
    if (activeType === PHARMACY_REQUEST_TYPE.PRODUCT) {
      setRequestData(managePharmacyRequestData?.products)
      setFilteredRequestData(managePharmacyRequestData?.products)
      return
    }

    setRequestData(managePharmacyRequestData?.supplier)
    setFilteredRequestData(managePharmacyRequestData?.supplier)
  }, [activeType, managePharmacyRequestData])

  useEffect(() => {
    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      console.log('home screen permission: ', permission)
      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    if (!searchTerm) return
    let rData = individualPlatformData?.filter((product) =>
      product?.name?.toUpperCase()?.includes(searchTerm?.toUpperCase())
    )

    setFilteredIndividualPlatformData(rData)
  }, [searchTerm, refilterTrigger])

  const getBranchData = async () => {
    try {
      let data = await getPharmacyDataHelper()
      setSupplierData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const getPlatformChargesData = async () => {
    try {
      let data = await getPlatformChargesHelper()
      setPlatformChargesData(data)
      setIndividualPlatformData(data.individual)
      setFilteredIndividualPlatformData(data.individual)
      setUniversalPlatformPercentage(data?.universal?.commission)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const updateUniversalPlatformCharges = async () => {
    try {
      // let commision = 7.8

      if (!isUniversalEdited) return
      let data = await updateUniversalPlatformChargesHelper(
        universalPlatformPercentage
      )
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const getCustomerPlatformChargesData = async () => {
    try {
      let data = await getCustomerPlatformChargesHelper()

      setUniversalCustomerPlatformCharges(data.universal)
      // setUniversalPlatformPercentage(data?.universal?.commission)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const updateCustomerPlatformCharges = async () => {
    try {
      if (!isUniversalEdited) return
      let data = await updateCustomerPlatformChargesHelper(
        universalCustomerPlatformCharges
      )
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const updateIndividualPlatformCharges = async () => {
    try {
      // let commision = 7.8

      let individual = [...individualPlatformData]
      if (isAddRowActive) {
        individual.push({
          commission: individualPlatform,
          branch_id: selectedSupplier?.id,
          isEdited: true,
        })
      }

      let filtered = individual.filter((data) => data.isEdited === true)

      if (filtered?.length <= 0) return

      let data = await upsertIndividualPlatformChargesHelper(filtered)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const handleSave = async () => {
    console.log('save clicked')
    if (activeType === PLATFORM_CHARGE_TYPE.PHARMACY_STORE) {
      await updateUniversalPlatformCharges()
      await updateIndividualPlatformCharges()

      console.log('in save before platform')
      getPlatformChargesData()
    } else {
      updateCustomerPlatformCharges()

      getCustomerPlatformChargesData()
    }

    setAddRowActive(false)
    setRowEditId(undefined)
    setUniversalEdited(false)
    setIndividualEdited(false)
    resetNewIndividualPlatform()
  }

  const handleDelete = async (id) => {
    try {
      let data = await deleteIndividualPlatformChargesHelper(id)
      getPlatformChargesData()
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const addEmptyPlatformRow = () => {
    let data = {
      commission: '',
      branch_id: '',
    }
  }

  const resetNewIndividualPlatform = () => {
    setSelectedSupplier(undefined)
    setIndividualPlatform('')
  }

  const handleRowEdit = (type, commisionData, data) => {
    let individual = [...individualPlatformData]
    let index = individualPlatformData.findIndex(
      (data) => data?.id === commisionData.id
    )
    let row = individual[index]

    if (type === 'supplier') {
      individual[index] = {
        ...row,
        branch_id: data?.id,
        name: data?.name,
        isEdited: true,
      }
    } else if (type === 'commision') {
      individual[index] = {
        ...row,
        commission: data,
        isEdited: true,
      }
    }

    setIndividualPlatformData(individual)
    setIndividualEdited(true)

    if (!searchTerm) setFilteredIndividualPlatformData(individual)
    else setRefilterTrigger((prev) => prev + 1)
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Product or Supplier Name"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">
              Manage Platform Charges
            </div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search Pharmacy Name"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
              {((permissions?.features?.[
                PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_CONSUMER
              ] === PERMISSION_TYPE.MANAGE &&
                activeType === PLATFORM_CHARGE_TYPE.CUSTOMER) ||
                (permissions?.features?.[
                  PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_PHARMACY_STORE
                ] === PERMISSION_TYPE.MANAGE &&
                  activeType === PLATFORM_CHARGE_TYPE.PHARMACY_STORE)) && (
                <button
                  disabled={!isSaveButtonActive}
                  className="btn btnPrimary ml-4"
                  onClick={() => {
                    handleSave()
                  }}
                >
                  SAVE
                </button>
              )}
            </div>
          </div>
        )}
        <div className="salesWrapper mt-5">
          <ul className="tabs dFlex">
            {permissions?.features?.[
              PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_PHARMACY_STORE
            ] !== PERMISSION_TYPE.RESTRICTED && (
              <li
                className={`tabItem ${
                  activeType === PLATFORM_CHARGE_TYPE.PHARMACY_STORE
                    ? 'active'
                    : ''
                }`}
                onClick={() =>
                  setActiveType(PLATFORM_CHARGE_TYPE.PHARMACY_STORE)
                }
              >
                Pharmacy Store
              </li>
            )}
            {permissions?.features?.[
              PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_CONSUMER
            ] !== PERMISSION_TYPE.RESTRICTED && (
              <li
                className={`tabItem ${
                  activeType === PLATFORM_CHARGE_TYPE.CUSTOMER ? 'active' : ''
                }`}
                onClick={() => setActiveType(PLATFORM_CHARGE_TYPE.CUSTOMER)}
              >
                Customer
              </li>
            )}
          </ul>
        </div>
        <div className="platformChargesBody">
          {activeType === PLATFORM_CHARGE_TYPE.CUSTOMER && (
            <div className="universalPlatformCharges dFlex ai-flex-end ml-4">
              <div className="universalPlatformText">
                Set the universal Platform Charges:
              </div>
              <div className="formGroup formFloating formInputText platformChargesInput">
                <div className="preInputGroup backColor">
                  <div className="preInputText">BDT</div>
                </div>
                <input
                  type="text"
                  className="formControl"
                  id="platformChargesInputPercentage"
                  placeholder="BDT"
                  value={universalCustomerPlatformCharges?.commission}
                  onChange={(e) => {
                    setUniversalEdited(true)
                    setUniversalCustomerPlatformCharges(e?.target?.value)
                  }}
                  required
                />
                <label for="platformChargesInputPercentage">BDT</label>
                {false && (
                  <div class="invalidFeedback">
                    Please enter a valid Amount.
                  </div>
                )}
              </div>
              <div className="universalPlatformUpdatedBy ml-2">
                Last Applied by:{' '}
                {universalCustomerPlatformCharges?.last_updated_by}
              </div>
            </div>
          )}
          {activeType === PLATFORM_CHARGE_TYPE.PHARMACY_STORE && (
            <>
              <div className="universalPlatformCharges dFlex ai-flex-end ml-4">
                <div className="universalPlatformText">
                  Set the universal % Platform Charges
                </div>
                <div className="formGroup formFloating formInputText platformChargesInput">
                  <div className="preInputGroup backColor">
                    <div className="preInputText">%</div>
                  </div>
                  <input
                    type="text"
                    className="formControl"
                    id="platformChargesInputPercentage"
                    placeholder="Pct"
                    value={universalPlatformPercentage}
                    onChange={(e) => {
                      setUniversalEdited(true)
                      setUniversalPlatformPercentage(e?.target?.value)
                    }}
                    required
                  />
                  <label for="platformChargesInputPercentage">Pct</label>
                  {false && (
                    <div class="invalidFeedback">
                      Please enter a valid Percentage.
                    </div>
                  )}
                </div>
                <div className="universalPlatformUpdatedBy ml-2">
                  Last Applied by:{' '}
                  {platformChargesData?.universal?.last_updated_by}
                </div>
              </div>
              <div className="individualPlatformCharges ml-4">
                <div className="individualPlatformHeading">
                  Set the individual % Platform Charge
                </div>
                <table className="table earningTable">
                  <thead>
                    <tr>
                      <td width="1%"></td>

                      <td width="30%">Pharmacy Store</td>
                      <td width="15%">%Commission</td>
                      <td width="20%">Applied by</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredIndividualPlatformData?.map((commisionData) => {
                      return (
                        <tr key={commisionData?.id}>
                          <td>
                            <div className="cardHeaderRight">
                              {activeRowId === commisionData?.id ? (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setActiveRowId(undefined)
                                  }}
                                >
                                  <CloseIcon />
                                </span>
                              ) : (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setActiveRowId(commisionData?.id)
                                  }}
                                >
                                  <DotsIcon />
                                </span>
                              )}
                              {activeRowId === commisionData?.id && (
                                <ul
                                  className={`cardActionsWrapper ${
                                    activeRowId === commisionData?.id
                                      ? 'show'
                                      : 'hide'
                                  }`}
                                >
                                  <li
                                    className="actionItem"
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setRowEditId(commisionData?.id)
                                      setActiveRowId(undefined)
                                    }}
                                  >
                                    Edit
                                  </li>
                                  <li
                                    className="actionItem"
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      handleDelete(commisionData?.id)
                                    }}
                                  >
                                    Delete
                                  </li>
                                </ul>
                              )}
                            </div>
                          </td>
                          <td>
                            {rowEditId !== commisionData?.id &&
                              commisionData.name}
                            {rowEditId === commisionData?.id && (
                              <Select
                                className="formSelect reactSelect"
                                id="floatingSelect"
                                // isDisabled={
                                //     props.product?.[
                                //         PRODUCT_DETAIL_FIELDS.SELECTED_PRODUCT
                                //     ]?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY] ||
                                //     props.isViewOnlyProduct
                                // }
                                value={commisionData}
                                options={supplierData}
                                onChange={(option) => {
                                  handleRowEdit(
                                    'supplier',
                                    commisionData,
                                    option
                                  )
                                }}
                                placeholder="Select Branch"
                                styles={{
                                  control: (base) => ({
                                    border: 0,
                                    display: 'flex',
                                    paddingTop: '20px',
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused
                                      ? 'rgb(222, 235, 255)'
                                      : state.isSelected
                                        ? '#FFF'
                                        : 'inherit',
                                    color: '#212529',
                                    '&:hover': {
                                      backgroundColor: state.isSelected
                                        ? '#DEEBFF'
                                        : 'rgb(222, 235, 255)',
                                    },
                                  }),
                                }}
                                getOptionLabel={(option) => option.name}
                                isClearable
                              />
                            )}
                          </td>
                          <td>
                            {rowEditId !== commisionData?.id &&
                              commisionData.commission}
                            {rowEditId === commisionData?.id && (
                              // <div className="formGroup mt-2 fgrow1">
                              <input
                                type="text"
                                className="formControl"
                                id="phone"
                                placeholder={`Percentage`}
                                value={commisionData?.commission}
                                onChange={(e) => {
                                  handleRowEdit(
                                    'commision',
                                    commisionData,
                                    e.target.value
                                  )
                                }}
                                required
                              />
                              // </div>
                            )}
                          </td>
                          <td>{commisionData.last_updated_by}</td>
                        </tr>
                      )
                    })}

                    {isAddRowActive && (
                      <tr key={'new'}>
                        <td>
                          <div
                            className="cardHeaderRight"
                            onClick={() => setAddRowActive(false)}
                          >
                            <MinusIcon />
                          </div>
                        </td>
                        <td>
                          {/* <div className="formGroup mt-2 fgrow1"> */}
                          <Select
                            className="formSelect reactSelect"
                            id="floatingSelect"
                            // isDisabled={
                            //     props.product?.[
                            //         PRODUCT_DETAIL_FIELDS.SELECTED_PRODUCT
                            //     ]?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY] ||
                            //     props.isViewOnlyProduct
                            // }
                            value={selectedSupplier}
                            options={supplierData}
                            onChange={(option) => {
                              setSelectedSupplier(option)
                            }}
                            placeholder="Select Branch"
                            styles={{
                              control: (base) => ({
                                border: 0,
                                display: 'flex',
                                paddingTop: '20px',
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                  ? 'rgb(222, 235, 255)'
                                  : state.isSelected
                                    ? '#FFF'
                                    : 'inherit',
                                color: '#212529',
                                '&:hover': {
                                  backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : 'rgb(222, 235, 255)',
                                },
                              }),
                            }}
                            getOptionLabel={(option) => option.name}
                            isClearable
                          />
                          {/* </div> */}
                        </td>
                        <td>
                          {/* <div className="formGroup mt-2 fgrow1"> */}
                          <input
                            type="text"
                            className="formControl"
                            id="phone"
                            placeholder={`Percentage`}
                            value={individualPlatform}
                            onChange={(e) => {
                              setIndividualPlatform(e.target.value)
                            }}
                            required
                          />
                          {/* <label for="phone">{`Enter `}</label> */}
                          {/* {isFieldErrorVisible &&
                                                fileFromState.name &&
                                                !fileFromState?.number && (
                                                    <div className="invalidFeedback">
                                                        Please enter a valid
                                                        Document Number.
                                                    </div>
                                                )} */}
                          {/* </div> */}
                        </td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {!isAddRowActive && (
                <div
                  className="ml-4 addPlatformCharges"
                  onClick={() => setAddRowActive(true)}
                >
                  <AddEarningIcon />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProductAlertAction: (payload) =>
      dispatch(addProductAlertAction(payload)),
    updateSupplierAlertAction: (payload) =>
      dispatch(updateSupplierAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlatformCharges)
